// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import Numeral from "numeral";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Db$Coronate from "./Db.res.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.res.js";
import * as ReactFeather from "react-feather";
import * as Hooks$Coronate from "./Hooks.res.js";
import * as Utils$Coronate from "./Utils.res.js";
import * as Window$Coronate from "./Window.res.js";
import * as Data_Id$Coronate from "./Data/Data_Id.res.js";
import * as Octokit$Coronate from "./Externals/Octokit.res.js";
import * as DemoData$Coronate from "./testdata/DemoData.res.js";
import * as TestData$Coronate from "./testdata/TestData.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Data_Config$Coronate from "./Data/Data_Config.res.js";
import * as Data_Player$Coronate from "./Data/Data_Player.res.js";
import * as HtmlEntities$Coronate from "./HtmlEntities.res.js";
import NetlifyAuthProviders from "netlify-auth-providers";
import * as Data_Tournament$Coronate from "./Data/Data_Tournament.res.js";

function getDateForFile() {
  var date = new Date();
  return [
            String(date.getFullYear()),
            Numeral(date.getMonth() + 1.0).format("00"),
            Numeral(date.getDate()).format("00")
          ].join("-");
}

function dictToMap(dict) {
  return Data_Id$Coronate.$$Map.fromStringArray(Js_dict.entries(dict));
}

function mapToDict(map) {
  return Js_dict.fromArray(Data_Id$Coronate.$$Map.toStringArray(map));
}

function decodeOptions(json) {
  var d = Belt_Option.getExn(Js_json.decodeObject(json));
  return {
          config: Data_Config$Coronate.decode(Belt_Option.getExn(Js_dict.get(d, "config"))),
          players: Belt_Map.map(dictToMap(Belt_Option.getExn(Belt_Option.flatMap(Js_dict.get(d, "players"), Js_json.decodeObject))), Data_Player$Coronate.decode),
          tournaments: Belt_Map.map(dictToMap(Belt_Option.getExn(Belt_Option.flatMap(Js_dict.get(d, "tournaments"), Js_json.decodeObject))), Data_Tournament$Coronate.decode)
        };
}

function encodeOptions(data) {
  return Js_dict.fromArray([
              [
                "config",
                Data_Config$Coronate.encode(data.config)
              ],
              [
                "players",
                mapToDict(Belt_Map.map(data.players, Data_Player$Coronate.encode))
              ],
              [
                "tournaments",
                mapToDict(Belt_Map.map(data.tournaments, Data_Tournament$Coronate.encode))
              ]
            ]);
}

function PageOptions$LastBackupDate(props) {
  var date = props.date;
  if (date.getTime() === 0.0) {
    return "Never";
  } else {
    return JsxRuntime.jsx(Utils$Coronate.DateTimeFormat.make, {
                date: date
              });
  }
}

var dateFormatter = new (Intl.DateTimeFormat)(["en-US"], {
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      month: "2-digit",
      year: "2-digit"
    });

var site_id = process.env.NETLIFY_ID;

var netlifyopts = site_id !== undefined ? ({
      site_id: site_id
    }) : ({});

function PageOptions$GistOpts(props) {
  var loadJson = props.loadJson;
  var configDispatch = props.configDispatch;
  var exportData = props.exportData;
  var match = Db$Coronate.useAuth();
  var authDispatch = match[1];
  var auth = match[0];
  var minify = Hooks$Coronate.useBool(true);
  var match$1 = React.useState(function () {
        return [];
      });
  var setGists = match$1[1];
  var cancelAllEffects = {
    contents: false
  };
  var handleAuthError = function (e) {
    console.error(e);
    if (!cancelAllEffects.contents) {
      authDispatch("Reset");
    }
    return Promise.resolve();
  };
  var loadGistList = function (auth) {
    var token = auth.github_token;
    if (token === "") {
      return Promise.resolve(setGists(function (param) {
                      return [];
                    }));
    } else {
      return Core__Promise.$$catch(Octokit$Coronate.Gist.list(token).then(function (data) {
                      if (!cancelAllEffects.contents) {
                        setGists(function (param) {
                              return data;
                            });
                        if (!Belt_Array.some(data, (function (x) {
                                  return x.id === auth.github_gist_id;
                                }))) {
                          return authDispatch("RemoveGistId");
                        } else {
                          return ;
                        }
                      }
                      
                    }), handleAuthError);
    }
  };
  React.useEffect((function () {
          loadGistList(auth);
          return (function () {
                    cancelAllEffects.contents = true;
                  });
        }), [auth.github_token]);
  var match$2 = auth.github_token;
  var tmp = match$2 === "" ? JsxRuntime.jsx("button", {
          children: "Log in with GitHub",
          onClick: (function (e) {
              e.preventDefault();
              new NetlifyAuthProviders(netlifyopts).authenticate({
                    provider: "github",
                    scope: "gist"
                  }, (function (err, data) {
                      if (data !== undefined) {
                        if (!cancelAllEffects.contents) {
                          return authDispatch({
                                      TAG: "SetGitHubToken",
                                      _0: data.token
                                    });
                        } else {
                          return ;
                        }
                      } else {
                        if (err == null) {
                          console.error("Something wrong happened.");
                        } else {
                          console.error(err);
                        }
                        return ;
                      }
                    }));
            })
        }) : JsxRuntime.jsxs("a", {
          children: [
            "Change or remove your GitHub access ",
            JsxRuntime.jsx(ReactFeather.ExternalLink, {})
          ],
          href: "https://github.com/settings/connections/applications/" + process.env.GITHUB_APP_ID
        });
  var github_token = auth.github_token;
  var tmp$1 = github_token === "" ? null : JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("button", {
                  children: "Create a new gist",
                  onClick: (function (param) {
                      Core__Promise.$$catch(Octokit$Coronate.Gist.create(github_token, encodeOptions(exportData), minify.state).then(function (newGist) {
                                  if (!cancelAllEffects.contents) {
                                    authDispatch({
                                          TAG: "SetGistId",
                                          _0: newGist.data.id
                                        });
                                    configDispatch({
                                          TAG: "SetLastBackup",
                                          _0: new Date()
                                        });
                                  }
                                  window.alert("Data saved.");
                                }).then(function () {
                                return loadGistList(auth);
                              }), (function (e) {
                              window.alert("Backup failed. Check your GitHub credentials.");
                              return handleAuthError(e);
                            }));
                    })
                }),
            JsxRuntime.jsx("p", {
                  children: "Or select an existing gist.",
                  className: "caption-30"
                }),
            JsxRuntime.jsxs("select", {
                  children: [
                    JsxRuntime.jsx("option", {
                          children: "No gist selected.",
                          value: ""
                        }),
                    Belt_Array.map(match$1[0], (function (param) {
                            var id = param.id;
                            return JsxRuntime.jsxs("option", {
                                        children: [
                                          param.name,
                                          " | updated ",
                                          dateFormatter.format(param.updated_at)
                                        ],
                                        value: id
                                      }, id);
                          }))
                  ],
                  value: auth.github_gist_id,
                  onBlur: (function (e) {
                      var id = e.currentTarget.value;
                      authDispatch({
                            TAG: "SetGistId",
                            _0: id
                          });
                    }),
                  onChange: (function (e) {
                      var id = e.currentTarget.value;
                      authDispatch({
                            TAG: "SetGistId",
                            _0: id
                          });
                    })
                }),
            JsxRuntime.jsxs("p", {
                  children: [
                    JsxRuntime.jsx("button", {
                          children: "Backup to this gist",
                          disabled: auth.github_gist_id === "",
                          onClick: (function (param) {
                              var id = auth.github_gist_id;
                              if (id === "") {
                                console.error("Gist ID is blank.");
                                return ;
                              }
                              Core__Promise.$$catch(Octokit$Coronate.Gist.write(github_token, id, encodeOptions(exportData), minify.state).then(function (param) {
                                          if (!cancelAllEffects.contents) {
                                            configDispatch({
                                                  TAG: "SetLastBackup",
                                                  _0: new Date()
                                                });
                                          }
                                          window.alert("Data saved.");
                                        }).then(function () {
                                        return loadGistList(auth);
                                      }), (function (e) {
                                      window.alert("Backup failed. Check your GitHub credentials or try a different gist.");
                                      return handleAuthError(e);
                                    }));
                            })
                        }),
                    " ",
                    JsxRuntime.jsx("button", {
                          children: "Load from this gist",
                          disabled: auth.github_gist_id === "",
                          onClick: (function (param) {
                              var id = auth.github_gist_id;
                              if (id === "") {
                                console.error("Gist ID is blank.");
                                return ;
                              }
                              Core__Promise.$$catch(Octokit$Coronate.Gist.read(github_token, id).then(function (result) {
                                        loadJson(result);
                                      }), (function (e) {
                                      window.alert("That data is invalid! A more helpful error message could not be written yet.");
                                      return handleAuthError(e);
                                    }));
                            })
                        })
                  ]
                }),
            JsxRuntime.jsx("p", {
                  children: JsxRuntime.jsxs("label", {
                        children: [
                          JsxRuntime.jsx("input", {
                                checked: minify.state,
                                type: "checkbox",
                                onChange: (function (param) {
                                    if (minify.state) {
                                      return minify.setFalse();
                                    } else {
                                      return minify.setTrue();
                                    }
                                  })
                              }),
                          " Minify output."
                        ]
                      }),
                  className: "caption-30"
                })
          ]
        });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                      children: "Backup to GitHub"
                    }),
                JsxRuntime.jsxs("p", {
                      children: [
                        "With a GitHub account, you can save your data to a ",
                        JsxRuntime.jsxs("a", {
                              children: [
                                "gist ",
                                JsxRuntime.jsx(ReactFeather.ExternalLink, {})
                              ],
                              href: "https://gist.github.com/"
                            }),
                        ". Note that gists can be " + HtmlEntities$Coronate.ldquo + "secret" + HtmlEntities$Coronate.rdquo + " but are always \n        publicly accessible. For more information, ",
                        JsxRuntime.jsxs("a", {
                              children: [
                                "refer to the gist documentation on GitHub ",
                                JsxRuntime.jsx(ReactFeather.ExternalLink, {})
                              ],
                              href: "https://docs.github.com/en/github/writing-on-github/creating-gists"
                            }),
                        "."
                      ],
                      className: "caption-30"
                    }),
                JsxRuntime.jsx("p", {
                      children: tmp
                    }),
                tmp$1
              ]
            });
}

function PageOptions(props) {
  var __windowDispatch = props.windowDispatch;
  var windowDispatch = __windowDispatch !== undefined ? __windowDispatch : (function (param) {
        
      });
  var match = Db$Coronate.useAllTournaments();
  var tourneysDispatch = match.dispatch;
  var tournaments = match.items;
  var match$1 = Db$Coronate.useAllPlayers();
  var playersDispatch = match$1.dispatch;
  var players = match$1.items;
  var match$2 = React.useState(function () {
        return "";
      });
  var setText = match$2[1];
  var text = match$2[0];
  var match$3 = Db$Coronate.useConfig();
  var configDispatch = match$3[1];
  var config = match$3[0];
  React.useEffect((function () {
          windowDispatch({
                TAG: "SetTitle",
                _0: "Options"
              });
          return (function () {
                    windowDispatch({
                          TAG: "SetTitle",
                          _0: ""
                        });
                  });
        }), [windowDispatch]);
  var exportData = React.useMemo((function () {
          return {
                  config: config,
                  players: players,
                  tournaments: tournaments
                };
        }), [
        config,
        tournaments,
        players
      ]);
  var exportDataURI = encodeURIComponent(JSON.stringify(encodeOptions(exportData)));
  React.useEffect((function () {
          var encoded = encodeOptions(exportData);
          var json = JSON.stringify(encoded, null, 2);
          setText(function (param) {
                return json;
              });
        }), [
        exportData,
        setText
      ]);
  var loadData = function (tournaments, players, config) {
    tourneysDispatch({
          TAG: "SetAll",
          _0: tournaments
        });
    configDispatch({
          TAG: "SetState",
          _0: config
        });
    playersDispatch({
          TAG: "SetAll",
          _0: players
        });
    window.alert("Data loaded.");
  };
  var loadJson = function (json) {
    try {
      var match = decodeOptions(JSON.parse(json));
      return loadData(match.tournaments, match.players, match.config);
    }
    catch (raw_e){
      var e = Caml_js_exceptions.internalToOCamlException(raw_e);
      console.error(e);
      window.alert("That data is invalid! A more helpful error message could not be written yet.");
      return ;
    }
  };
  var handleText = function ($$event) {
    $$event.preventDefault();
    loadJson(text);
  };
  var handleFile = function ($$event) {
    $$event.preventDefault();
    var reader = new FileReader();
    var onload = function (ev) {
      var data = ev.target.result;
      try {
        var match = decodeOptions(JSON.parse(data));
        return loadData(match.tournaments, match.players, match.config);
      }
      catch (raw_e){
        var e = Caml_js_exceptions.internalToOCamlException(raw_e);
        console.error(e);
        window.alert("That data is invalid! A more helpful error message could not be written yet.");
        return ;
      }
    };
    reader.onload = onload;
    reader.readAsText(Belt_Option.getWithDefault(Belt_Array.get($$event.currentTarget.files, 0), ""));
    $$event.currentTarget["value"] = "";
  };
  var reloadDemoData = function ($$event) {
    $$event.preventDefault();
    loadData(DemoData$Coronate.tournaments, DemoData$Coronate.players, DemoData$Coronate.config);
  };
  var loadTestData = function ($$event) {
    $$event.preventDefault();
    loadData(TestData$Coronate.tournaments, TestData$Coronate.players, TestData$Coronate.config);
  };
  var handleTextChange = function ($$event) {
    var newText = $$event.currentTarget.value;
    setText(function (param) {
          return newText;
        });
  };
  var match$4 = config.byeValue;
  var tmp;
  switch (match$4) {
    case "Full" :
        tmp = true;
        break;
    case "Half" :
    case "Zero" :
        tmp = false;
        break;
    
  }
  var match$5 = config.byeValue;
  var tmp$1;
  switch (match$5) {
    case "Half" :
        tmp$1 = true;
        break;
    case "Full" :
    case "Zero" :
        tmp$1 = false;
        break;
    
  }
  var match$6 = config.byeValue;
  var tmp$2;
  switch (match$6) {
    case "Full" :
    case "Half" :
        tmp$2 = false;
        break;
    case "Zero" :
        tmp$2 = true;
        break;
    
  }
  var s = Data_Config$Coronate.aliasToOption(config.whiteAlias);
  var s$1 = Data_Config$Coronate.aliasToOption(config.blackAlias);
  return JsxRuntime.jsx(Window$Coronate.Body.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("h2", {
                            children: "Bye settings"
                          }),
                      JsxRuntime.jsxs("form", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Select the default score given to a player who takes a bye.",
                                    className: "caption-30"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("label", {
                                            children: [
                                              "Full (",
                                              JsxRuntime.jsx("span", {
                                                    children: "1",
                                                    className: "monospace"
                                                  }),
                                              ") ",
                                              JsxRuntime.jsx("input", {
                                                    checked: tmp,
                                                    type: "radio",
                                                    onChange: (function (param) {
                                                        configDispatch({
                                                              TAG: "SetByeValue",
                                                              _0: "Full"
                                                            });
                                                      })
                                                  })
                                            ],
                                            className: "body-20",
                                            style: {
                                              marginRight: "16px"
                                            }
                                          }),
                                      JsxRuntime.jsxs("label", {
                                            children: [
                                              "Half (",
                                              JsxRuntime.jsx("span", {
                                                    children: "½",
                                                    className: "monospace"
                                                  }),
                                              ") ",
                                              JsxRuntime.jsx("input", {
                                                    checked: tmp$1,
                                                    type: "radio",
                                                    onChange: (function (param) {
                                                        configDispatch({
                                                              TAG: "SetByeValue",
                                                              _0: "Half"
                                                            });
                                                      })
                                                  })
                                            ],
                                            className: "body-20",
                                            style: {
                                              marginRight: "16px"
                                            }
                                          }),
                                      JsxRuntime.jsxs("label", {
                                            children: [
                                              "None (",
                                              JsxRuntime.jsx("span", {
                                                    children: "0",
                                                    className: "monospace"
                                                  }),
                                              ") ",
                                              JsxRuntime.jsx("input", {
                                                    checked: tmp$2,
                                                    type: "radio",
                                                    onChange: (function (param) {
                                                        configDispatch({
                                                              TAG: "SetByeValue",
                                                              _0: "Zero"
                                                            });
                                                      })
                                                  })
                                            ],
                                            className: "body-20"
                                          })
                                    ],
                                    style: {
                                      display: "flex"
                                    }
                                  })
                            ]
                          }),
                      JsxRuntime.jsx("h2", {
                            children: "Player labels"
                          }),
                      JsxRuntime.jsxs("form", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Use custom labels for opposing players.",
                                    className: "caption-30"
                                  }),
                              JsxRuntime.jsxs("label", {
                                    children: [
                                      "Player 1: ",
                                      JsxRuntime.jsx("input", {
                                            placeholder: Data_Config$Coronate.aliasToStringWhite(Data_Config$Coronate.default),
                                            type: "text",
                                            value: s !== undefined ? s : "",
                                            onChange: (function ($$event) {
                                                configDispatch({
                                                      TAG: "SetWhiteAlias",
                                                      _0: $$event.target.value
                                                    });
                                              })
                                          })
                                    ],
                                    className: "body-20"
                                  }),
                              JsxRuntime.jsxs("label", {
                                    children: [
                                      "Player 2: ",
                                      JsxRuntime.jsx("input", {
                                            placeholder: Data_Config$Coronate.aliasToStringBlack(Data_Config$Coronate.default),
                                            type: "text",
                                            value: s$1 !== undefined ? s$1 : "",
                                            onChange: (function ($$event) {
                                                configDispatch({
                                                      TAG: "SetBlackAlias",
                                                      _0: $$event.target.value
                                                    });
                                              })
                                          })
                                    ],
                                    className: "body-20"
                                  })
                            ]
                          }),
                      JsxRuntime.jsx("h2", {
                            children: "Manage data"
                          }),
                      JsxRuntime.jsxs("p", {
                            children: [
                              "Last export: ",
                              JsxRuntime.jsx(PageOptions$LastBackupDate, {
                                    date: config.lastBackup
                                  })
                            ],
                            className: "caption-20"
                          }),
                      JsxRuntime.jsx(PageOptions$GistOpts, {
                            exportData: exportData,
                            configDispatch: configDispatch,
                            loadJson: loadJson
                          }),
                      JsxRuntime.jsx("h3", {
                            children: "Backup locally"
                          }),
                      JsxRuntime.jsx("p", {
                            children: JsxRuntime.jsxs("a", {
                                  children: [
                                    JsxRuntime.jsx(ReactFeather.Download, {}),
                                    " Export data to a file."
                                  ],
                                  download: "coronate-" + (getDateForFile() + ".json"),
                                  href: "data:application/json," + exportDataURI,
                                  onClick: (function (param) {
                                      configDispatch({
                                            TAG: "SetLastBackup",
                                            _0: new Date()
                                          });
                                    })
                                })
                          }),
                      JsxRuntime.jsx("label", {
                            children: "Load data from a file:",
                            htmlFor: "file"
                          }),
                      JsxRuntime.jsx("input", {
                            id: "file",
                            name: "file",
                            type: "file",
                            onChange: handleFile
                          }),
                      JsxRuntime.jsx("h2", {
                            children: "Danger zone"
                          }),
                      JsxRuntime.jsx("p", {
                            children: "I hope you know what you're doing...",
                            className: "caption-30"
                          }),
                      JsxRuntime.jsx("button", {
                            children: "Reset demo data (this erases everything else)",
                            onClick: reloadDemoData
                          }),
                      " ",
                      process.env.NODE_ENV !== "production" ? JsxRuntime.jsx("button", {
                              children: "Load testing data",
                              onClick: loadTestData
                            }) : null,
                      JsxRuntime.jsx("h3", {
                            children: "Advanced: manually edit data"
                          }),
                      JsxRuntime.jsxs("form", {
                            children: [
                              JsxRuntime.jsx("textarea", {
                                    className: "pages__text-json",
                                    spellCheck: false,
                                    cols: 50,
                                    name: "playerdata",
                                    rows: 25,
                                    value: text,
                                    onChange: handleTextChange
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: JsxRuntime.jsx("input", {
                                          type: "submit",
                                          value: "Load"
                                        })
                                  })
                            ],
                            onSubmit: handleText
                          })
                    ],
                    className: "content-area"
                  }),
              windowDispatch: windowDispatch
            });
}

var make = PageOptions;

export {
  make ,
}
/* dateFormatter Not a pure module */
